<template>
  <v-layout :loading="loading">
    <div
      class="py-14 sm:pb-36"
    >
      <div class="container max-w-md">
        <img
          src="/img/icons/svg/streamline-icon-task-checklist-check@48x48.svg"
          alt="Subscription"
          class="w-20 mx-auto mb-5"
        >

        <h1 class="title-1 mb-0 text-center">
          Subscription
        </h1>

        <div
          class="card mt-8"
        >
          <p class="mb-5 text-sm text-justify">
            The amount below is a calculation based on your current carbon footprint. By subscribing, you offset your full carbon footprint for the year.
          </p>
          <p class="mb-5 text-lg">
            <b>{{ ($laravel.user.price_to_pay_per_month).priceFormat() }}</b> / month
          </p>

          <!-- Stripe Elements Placeholder -->
          <div class="p-4 border border-gray-200 rounded-md">
            <div ref="cardElement" />
          </div>

          <button
            v-if="!loading"
            class="btn btn-primary w-full mt-8"
            @click="onSubscribe"
          >
            Subscribe now
          </button>
        </div>
      </div>
    </div>
  </v-layout>
</template>
<script>
export default {
  name: "v-subscription",
  data() {
    return {
      loading: false,
      userSetupIntent: null,
      stripe: null,
      stripeCardElement: null,
    };
  },
  created() {
    this.fetchUserSetupIntent();
  },
  mounted() {
    this.stripe = Stripe(this.$laravel.stripe_public_key,{locale: "en"});
    this.mountStripeForm();
  },
  methods: {
    fetchUserSetupIntent() {
      this.loading = true;
      this.$http.get(this.$laravel.route("api.subscription.user_setup_intent")).then(
        (response) => {
          this.userSetupIntent = response.data.intent;
        }
      ).finally(
        () => {
          this.loading = false;
        }
      );
    },
    mountStripeForm() {
      const elements = this.stripe.elements();
      const cardElement = elements.create("card");
      cardElement.mount(this.$refs.cardElement);
      this.stripeCardElement = cardElement;
    },
    onSubscribe() {
      this.loading = true;
      this.confirmCard().then(
        (result) => {
          if (result.error) {
            this.$notificator.error(result.error.message);
            this.loading = false;
            return;
          }
          if (result.setupIntent) {
            this.subscribe({
              payment_method: result.setupIntent.payment_method
            });
          }
        }
      );
    },
    confirmCard() {
      return this.stripe.confirmCardSetup(
        this.userSetupIntent.client_secret, {
          payment_method: {
            card: this.stripeCardElement,
            billing_details: {name: this.$laravel.user.full_name}
          }
        }
      );
    },
    subscribe(request) {
      this.$http.post(this.$laravel.route("api.subscription.subscribe"),request).then(
        (response) => {
          this.$notificator.success(response.data.message);
          window.location.href="/app/billing";          }
      ).catch(
        (error) => {
          this.loading = false;
        }
      );
    }
  }

};
</script>
